export interface PreMountErrorView {
  title: string
  summary?: unknown
  detail?: unknown
  reload?: () => void
}

export function renderPreMountError(view: PreMountErrorView): boolean {
  const root = document.getElementById('root')
  if (!root || root.hasChildNodes()) return false

  const panel = document.createElement('div')
  panel.style.cssText = 'padding:20px;font-family:monospace;background:#1a202c;color:#fc8181;min-height:100vh'

  const heading = document.createElement('h2')
  heading.style.color = '#e53e3e'
  // Diagnostics can carry callback credentials even after URL scrubbing.
  // Do not read/coerce them: this public fallback uses fixed text only.
  heading.textContent = 'Unable to start VitaHelm'
  panel.appendChild(heading)

  const summary = document.createElement('p')
  summary.textContent = 'Please reload to try again. Private error details are not displayed.'
  panel.appendChild(summary)

  const detail = document.createElement('pre')
  detail.style.cssText = 'background:#2d1b1b;padding:16px;border-radius:4px;overflow:auto;font-size:12px;color:#fbd38d'
  detail.textContent = 'STARTUP_FAILED'
  panel.appendChild(detail)

  const reload = document.createElement('button')
  reload.type = 'button'
  reload.style.cssText = 'margin-top:16px;padding:10px 20px;background:#3182ce;color:white;border:none;border-radius:6px;cursor:pointer;font-size:14px'
  reload.textContent = '🔄 Reload'
  reload.addEventListener('click', view.reload || (() => window.location.reload()))
  panel.appendChild(reload)

  root.replaceChildren(panel)
  return true
}
